import building from '../Assets/building-2-fill.svg'
import medal from '../Assets/medal-fill.svg'
import Team from '../Assets/Team.svg'
import Beaconhill from '../Assets/Beaconhill-staffing.svg';
import Alpine from '../Assets/Alpine.svg';
import Experis from '../Assets/experis-logo.svg';
import Info from '../Assets/InfoVision-Logo-200px.svg';
import Raj from '../Assets/Raj .svg'
import Akshara from '../Assets/Akshara.svg'



export const Achievement = [
    {
        Icon: medal,
        Count: 100,
        Title: "TRAINED PROFESSIONAL"
    }, {
        Icon: building,
        Count: 55,
        Title: "INDUSTRY PLACEMENTS"
    }, {
        Icon: Team,
        Count: 10,
        Title: "CLIENTS"
    }


]

export const ClienCompanyArray=[Beaconhill,Alpine,Experis,Info]

export const Partners = [
    {
        PartnerName: "Raj Kumar",
        PartnerIcon: Raj,
        PartnerCompany: "HCL",
        PartnerOpinion: "“ The Agilewit team demonstrates exceptional expertise and efficiency in problem-solving. I highly recommend Rav Business Stream. for data science projects. Their insights and support were instrumental in deriving accurate predictions and uncovering valuable business patterns.”"
    },
    {
        PartnerName: "Akshara",
        PartnerIcon: Akshara,
        PartnerCompany: "Director Of SK Instistution",
        PartnerOpinion: "“The UX/UI team at Agilewits Solutions Inc. delivered exceptional professional designs for my institution. Their attention to detail and creativity exceeded my expectations. I highly recommend Agilewits to any business partners looking for top-tier design solutions.”"
    }
]


export const HomePageContent = {
    HomeTitle: "See what  we can do for you",
    HomePageMainingHeading: 'Innovate with Our Tech Experts.',
    MobileViewCaption: `"Technology empowers us to dream beyond boundaries and make those dreams a reality"`,
    HomePageTagLine: "Elevate Your Business with Our Technology Consulting and Software Development Expertise",
    LetsWork: "LET'S WORK TOGETHER +",
    ShareYourIdea: `You Share your idea We get it done`,
    IdeaDescription: `Rav Business Stream is incorporated as a Technology Consulting services and Software product development firm. Head quartered in Texas and Offshore development centers in India, we are involved in creating strategy, implementing, deploying, and supporting a wide range of
    solutions for clients worldwide.`
}